export const TEXT_SIZES = [
  "xs",
  "sm",
  "base",
  "md",
  "lg",
  "xl",
  "1xl",
  "2xl",
  "3xl",
  "4xl",
  "5xl",
] as const;

export type TextSize = (typeof TEXT_SIZES)[number];

export const TEXT_SIZE_OPTIONS = [
  { title: "Extra Small (12px)", value: "xs" },
  { title: "Small (14px)", value: "sm" },
  { title: "Base (16px)", value: "base" },
  { title: "Medium (18px)", value: "md" },
  { title: "Large (24px)", value: "lg" },
  { title: "XL (32px)", value: "xl" },
  { title: "1XL (40px)", value: "1xl" },
  { title: "2XL (48px)", value: "2xl" },
  { title: "3XL (56px)", value: "3xl" },
  { title: "4XL (64px)", value: "4xl" },
  { title: "5XL (72px)", value: "5xl" },
] as const satisfies ReadonlyArray<{ title: string; value: TextSize }>;

export const TEXT_SIZE_CLASS: Record<TextSize, string> = {
  "1xl": "text-1xl",
  "2xl": "text-2xl",
  "3xl": "text-3xl",
  "4xl": "text-4xl",
  "5xl": "text-5xl",
  base: "text-base",
  lg: "text-lg",
  md: "text-md",
  sm: "text-sm",
  xl: "text-xl",
  xs: "text-xs",
};

export function resolveTextSizeClass(
  textSize: string | null | undefined,
  defaultSize: TextSize = "base",
): string {
  return (
    TEXT_SIZE_CLASS[(textSize ?? defaultSize) as TextSize] ??
    TEXT_SIZE_CLASS[defaultSize]
  );
}
